var exports = {
  "K": "icon__IeDwva",
  "I": "fullWidth__sTHBpe",
};

module.exports = exports;
